class GeoFeatureClusteredPoint {
    constructor(id, coordinates, color, timestamp) {
        this.id = id;
        this.coordinates = coordinates;
        this.color = color;
        this.timestamp = timestamp;
    }
}
export default GeoFeatureClusteredPoint;
